import React from "react";
import { type CaseStudySimple } from "lib/sanity";
import { DecorativeBackgroundImage } from "components/images";
import { Section, sectionSpacingY } from "components/section";
import { TextTitle } from "ui/text";
import { VideoModal } from "ui/video";
import { horizontalContainerPadding } from "ui/container";
import { CenteredSlider } from "./slider";
import { SliderCard } from "./slider-card";

const petsmartShort = "https://cdn.sanity.io/files/pwmfmi47/production/10756e213114aba50eb44269c201efc0be27f900.mp4";
const petsmartVideo = "https://cdn.sanity.io/files/pwmfmi47/production/d32cfe274623d8147658ece7363c7b838d00b374.mp4";
const petsmartCaptions = "/assets/home/petsmart-captions.vtt";
const petsmartThumbnail =
  "https://cdn.sanity.io/images/pwmfmi47/production/428b3051d614b60006c29dd8f70e3e59bc7df850-2108x1188.webp";

type CaseStudySliderProps = {
  petsmart: CaseStudySimple;
  weightWatchers: CaseStudySimple;
  wmg: CaseStudySimple;
  chime: CaseStudySimple;
  whoop: CaseStudySimple;
};

export function CaseStudySlider({ petsmart, weightWatchers, wmg, chime, whoop }: CaseStudySliderProps) {
  return (
    <Section fullWidth noContainerPx my={0} pb={sectionSpacingY}>
      <TextTitle
        align="center"
        mobileAlign="center"
        size="lg"
        title="Leaders are re-inventing marketing with their data. You can too."
        mb="biggest"
        px={horizontalContainerPadding}
      />

      <CenteredSlider>
        <SliderCard
          key="whoop-slide-card"
          title={whoop.title}
          caseStudy={whoop}
          media={<DecorativeBackgroundImage src={whoop.fullImageUrl} />}
        />
        <SliderCard
          key="wmg-slide-card"
          title="Warner Music Group leverages Hightouch to “super-serve” fans, artists, and labels"
          caseStudy={wmg}
          media={<DecorativeBackgroundImage src={wmg.fullImageUrl} />}
        />
        <SliderCard
          key="petsmart-slide-card"
          title="PetSmart personalizes journeys for over 70 million loyalty program members"
          caseStudy={petsmart}
          media={
            <VideoModal
              shortSrc={petsmartShort}
              src={petsmartVideo}
              captions={petsmartCaptions}
              thumbnail={petsmartThumbnail}
              uploadDate="Feb 10, 2025"
              videoId="petsmart-case-study"
              title="PetSmart powers personalization for 70M+ loyalty members and drives double-digit growth"
              description="Bradley Breuer, VP of Marketing at PetSmart, discusses how the company is delivering personalized experiences to millions of pet-owners using Composable CDP powered by Hightouch."
            />
          }
        />
        <SliderCard
          key="weight-watchers-slide-card"
          title="WeightWatchers boosts new member growth by 52% and reduces data onboarding by 2 weeks"
          caseStudy={weightWatchers}
          media={<DecorativeBackgroundImage src={weightWatchers.fullImageUrl} />}
        />
        <SliderCard
          key="chime-slide-card"
          title={chime.title}
          caseStudy={chime}
          media={<DecorativeBackgroundImage src={chime.fullImageUrl} />}
        />
      </CenteredSlider>
    </Section>
  );
}
